var map = {
	"./": 462,
	"./development": 1437,
	"./development.js": 1437,
	"./index": 462,
	"./index.js": 462,
	"./preprod": 1438,
	"./preprod.js": 1438,
	"./production": 1418,
	"./production.js": 1418,
	"./staging": 1439,
	"./staging.js": 1439
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3447;